import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

import { AsyncDependencyBoth } from '../base-classes/async-dependency-both';
import { FeriproGenericSite, GenericSite, Type } from '../models/custom-sites/custom-sites';
import { Logger } from '../providers/logger';

import { BackendCallService } from './backend-call.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class CustomSiteService extends AsyncDependencyBoth {

  private custom_sites$: BehaviorSubject<GenericSite[]> = new BehaviorSubject<GenericSite[]>([]);

  constructor(private backend: BackendCallService) {
    super();
    this.init(backend);
  }


  protected onReady() {
    const url = this.backend.get_feripro_backend_domain() + "/api/custom/pages";
    this.backend.get_with_token<FeriproGenericSite[]>(url).then(pages => {

      const published_pages: GenericSite[] = (pages || [])
        .map((p, i) => ({...p, order: i, type: ConfigService.string_to_enum(p.type, Type)}));
      
      this.custom_sites$.next(published_pages);
    })
    .catch(e => {
      if (e.status === 404) {
        // // for testing
        // const pages: GenericSite[] = [
        //   {"id": 1,"order": 1,"title":"Toller Titel","description":"# Dies ist eine Tolle Custom Page\r\n**Wow**","type":Type.NEWS,"created":"2022-11-30T21:24:43.773006"},
        //   {"id": 2,"order": 2,"title":"Toller Titel 2","description":"# Dies ist eine Tolle Custom Page\r\n**Wow**","type":Type.NEWS,"created":"2022-11-30T21:24:43.773006"},
        //   {"id": 3,"order": 3,"title":"Test-FAQ","description":"![](https://img.freepik.com/premium-photo/business-man-hand-holding-wooden-cube-with-faq-text_42256-1160.jpg?w=2000)\r\n[Credit](https://www.freepik.com/free-photos-vectors/faq)\r\n\r\nLorem ipsum dolor sit amet consectetur adipiscing elit ornare facilisi ad, augue non nascetur ante elementum cursus congue mauris nisl, rhoncus habitasse nec eros vulputate blandit pretium pharetra tristique. Sodales arcu ridiculus conubia proin suspendisse parturient mi sociosqu vivamus laoreet netus, convallis habitant cras curae morbi mauris eros nullam fermentum. Dui aptent porta netus ultricies class condimentum proin a himenaeos ut magnis, orci erat habitant habitasse suscipit faucibus senectus mi accumsan. \r\n\r\nScelerisque eget dictumst tellus inceptos gravida etiam penatibus eu, integer egestas auctor nostra duis volutpat pretium enim massa, lectus erat platea mollis primis aptent fringilla. Mauris pharetra curabitur phasellus morbi quis massa tempus curae, volutpat praesent elementum lobortis mi vel ac, tempor conubia dictumst ornare cubilia eu sociis. Vitae ultrices varius et himenaeos orci aptent augue laoreet, imperdiet non porttitor sociis vivamus mus nam mauris facilisis, ante morbi ridiculus in facilisi ut metus. \r\n\r\n## Fermentum quam nulla egestas ligula ultrici\r\n\r\n- Vulputate odio ad ac lobortis, ullamcorper semper scelerisque, vitae velit dignissim.\r\n\r\n- Himenaeos quisque lacinia habitasse donec, eros interdum sodales.\r\n\r\n- Ultrices at dui suscipit nullam pharetra, parturient facilisi dapibus.\r\n\r\n- Viverra suspendisse curabitur consequat, ligula hendrerit justo interdum, tristique parturient.\r\n\r\n\r\n\r\nHendrerit facilisis quisque non habitasse vitae feugiat cubilia lacinia id nulla arcu iaculis ullamcorper, praesent justo fames tempor mollis etiam cursus metus luctus porta semper sodales. Aptent donec diam etiam habitant elementum quis ante faucibus, interdum tempor platea laoreet vehicula eu senectus posuere praesent, montes a nullam curae ornare blandit massa. Neque dui rhoncus quis id sodales donec dis pretium dictum phasellus euismod cum, magna justo ridiculus ut vel vulputate erat nullam conubia at a.","type":Type.DEFAULT,"created":"2022-12-06T13:41:38.272799"}
        // ];
        // this.custom_sites$.next(pages);
      } else {
        Logger.error(e);
      }
    })
    .finally(() => this.set_ready());
  }

  get_custom_sites$(): Observable<GenericSite[]> {
    return this.custom_sites$.asObservable();
  }

  get_custom_sites_by_type$(type: Type): Observable<GenericSite[]> {
    return this.custom_sites$.asObservable().pipe(
      map(pages => pages.filter(p => p.type == type))
    );
  }
}
